import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCartIcon } from '@heroicons/react/24/outline';
import { useCart } from '../context/CartContext';

const NavBar = () => {
  const { cartItems } = useCart();
  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);
  const [menuOpen, setMenuOpen] = useState(false);
  const logoPath = require('../resources/logo.png');

  const navLinks = [
    { to: '/', label: 'Naslovna' },
    { to: '/shop', label: 'Prodavnica' },
    { to: '/blog', label: 'Blog' },
    { to: '/contact', label: 'Kontakt' },
  ];

  return (
    <nav className="header-bg-color text-white shadow-md px-4 py-4 flex items-center justify-between relative min-h-[120px]">
      <div className="w-24 flex items-center min-w-[100px]">
        <button
          className="md:hidden mr-2"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="Toggle Menu"
        >
          <div className="w-8 h-8 flex flex-col justify-center">
            <span className="block h-1 w-8 bg-gray-800 mb-1 rounded"></span>
            <span className="block h-1 w-8 bg-gray-800 mb-1 rounded"></span>
            <span className="block h-1 w-8 bg-gray-800 rounded"></span>
          </div>
        </button>
        <div className="hidden md:flex space-x-6">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="hover:underline font-medium"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
      <div className="flex-1 flex justify-center relative">
        <Link
          to="/"
          className="absolute top-1/2 -translate-y-1/2 flex items-center"
          style={{ pointerEvents: 'auto' }} // clickable
        >
          <img src={logoPath} alt="Logo" className="h-24 w-auto" />
        </Link>
      </div>
      <div className="w-24 relative flex items-center justify-center min-w-[100px]">
        <Link to="/cart">
          <ShoppingCartIcon className="h-8 w-8 text-white" />
          {cartCount > 0 && (
            <span className="absolute -top-2 right-7 bg-red-600 text-white text-xs rounded-full px-1">
              {cartCount}
            </span>
          )}
        </Link>
      </div>
      {menuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-white shadow z-50 flex flex-col items-center py-4">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="block py-2 text-lg w-full text-center hover:bg-gray-100 font-medium text-[var(--text-color)]"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default NavBar;
